module.exports = __webpack_public_path__ + "static/media/Ecstasy_1_Billboard.7e854364.jpg";